import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Users, Crown, Flame } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

export default function RecipeCard({ recipe, index = 0 }) {
  const { lang, t } = useLang();
  const title = lang === 'ar' ? recipe.title_ar : recipe.title_en;
  const desc = lang === 'ar' ? recipe.description_ar : recipe.description_en;
  const kcal = recipe?.nutrition?.kcal;
  return (
    <Link
      to={`/recipe/${recipe.recipe_id}`}
      data-testid={`recipe-card-${recipe.recipe_id}`}
      className="group block fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <article className="overflow-hidden rounded-3xl bg-white border border-black/5 shadow-sm hover:shadow-xl transition-all duration-300 group-hover:-translate-y-1">
        <div className="relative h-52 overflow-hidden">
          <img
            src={recipe.image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
          {recipe.premium && (
            <span className="absolute top-3 end-3 inline-flex items-center gap-1 bg-[#E29F48] text-white text-xs font-semibold px-3 py-1 rounded-full">
              <Crown className="h-3 w-3" /> {t('premium')}
            </span>
          )}
          {kcal ? (
            <span className="absolute top-3 start-3 inline-flex items-center gap-1 bg-black/55 backdrop-blur-md text-white text-xs font-semibold px-3 py-1 rounded-full">
              <Flame className="h-3 w-3" /> {kcal} {t('kcal')}
            </span>
          ) : null}
          <h3 className="absolute bottom-3 start-4 end-4 text-white text-xl font-display font-semibold drop-shadow-md line-clamp-2">
            {title}
          </h3>
        </div>
        <div className="p-5">
          <p className="text-sm text-[#5C4D44] line-clamp-2 leading-relaxed">{desc}</p>
          <div className="mt-3 flex items-center gap-4 text-xs text-[#5C4D44]">
            <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {recipe.prep_time + recipe.cook_time} {t('minutes')}</span>
            <span className="inline-flex items-center gap-1"><Users className="h-3.5 w-3.5" /> {recipe.servings}</span>
          </div>
        </div>
      </article>
    </Link>
  );
}
